export default __webpack_public_path__ + "static/media/amaranth-logo.5d3ed342.png";